import { render, staticRenderFns } from "./RecastRequest.vue?vue&type=template&id=35dbf476&"
import script from "./RecastRequest.vue?vue&type=script&lang=js&"
export * from "./RecastRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports